var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetwork1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.65 6.1C15.0584 6.1 16.2 4.95833 16.2 3.55C16.2 2.14167 15.0584 1 13.65 1C12.2417 1 11.1 2.14167 11.1 3.55C11.1 4.95833 12.2417 6.1 13.65 6.1Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.65 18C15.0584 18 16.2 16.8583 16.2 15.45C16.2 14.0416 15.0584 12.9 13.65 12.9C12.2417 12.9 11.1 14.0416 11.1 15.45C11.1 16.8583 12.2417 18 13.65 18Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45002 12.05C4.85835 12.05 6.00002 10.9083 6.00002 9.50001C6.00002 8.09169 4.85835 6.95001 3.45002 6.95001C2.0417 6.95001 0.900024 8.09169 0.900024 9.50001C0.900024 10.9083 2.0417 12.05 3.45002 12.05Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4468 4.83521L5.65491 8.21396M11.4468 14.1648L5.65491 10.7861",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork1);
export default __webpack_public_path__ + "static/media/network-1.71aacf6dffa76960a6615ee79edcc7cd.svg";
export { ForwardRef as ReactComponent };